/*
 * Swap the shown image when a variant picker changes.
 *
 * The gallery tiles and the chart rows both carry a compact variant picker so
 * people can buy without leaving the room. Until now the picture stayed on the
 * first variant, so choosing Dragon on an Aireo Cyclone still showed the black
 * one. That is the same silent-substitution problem the product page had: the
 * customer believes they are buying what they can see.
 *
 * The map is emitted by snippets/pickld-gallery-buy.liquid as JSON on the
 * form's wrapper. No map means nothing runs, which is the case for any product
 * whose variants share one image.
 *
 * How it finds things: one delegated change listener on the document. When a
 * select with the class pickld-gf__opt changes, it reads data-variant-images
 * from the nearest ancestor that has it, looks up the chosen variant id, climbs
 * to the nearest li, article or .pickld-gf__centre, and sets the src of the
 * FIRST img inside that scope (removing srcset so the old picture does not
 * win). It only follows the select in snippets/pickld-gallery-buy.liquid; the
 * shared buy row (snippets/pickld-buy-row.liquid) does not use it.
 *
 * Loaded by pickld-gallery-floor, pickld-chart and pickld-merch-counter.
 * Documentation: docs/components/gallery.md.
 *
 * Progressive enhancement: without JS the picker still posts the right variant
 * to the cart, the picture just does not follow.
 */
(function () {
  'use strict';

  function apply(select) {
    var host = select.closest('[data-variant-images]');
    if (!host) return;

    var map;
    try {
      map = JSON.parse(host.getAttribute('data-variant-images'));
    } catch (e) {
      return;
    }

    var src = map[select.value];
    if (!src) return;

    // The picture lives outside the form, so climb to the tile or row.
    var scope = select.closest('li, article, .pickld-gf__centre');
    if (!scope) return;

    var img = scope.querySelector('img');
    if (!img) return;

    img.setAttribute('src', src);
    // srcset would otherwise win and keep showing the old variant.
    img.removeAttribute('srcset');
  }

  document.addEventListener('change', function (event) {
    var el = event.target;
    if (el && el.classList && el.classList.contains('pickld-gf__opt')) {
      apply(el);
    }
  });
})();
